$(document).ready(function(){
    $('.mfclogos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        dots: false,
        pauseOnHover: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }]
    });
});

//=include _slider_news.js

$('.accordion').on('shown.bs.collapse', function(e){
   $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
});
$('.collapse').on('shown.bs.collapse', function(e){
   $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
});

$(document).ready(function() {
  var table = $('table.display').DataTable({
    responsive: true,
    rowReorder: {
      selector: 'td:nth-child(2)'
    },

  });
});
